import { render } from "./FloatingButton.vue?vue&type=template&id=2f7a1deb&scoped=true&bindings={}"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"

import "./FloatingButton.vue?vue&type=style&index=0&id=2f7a1deb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f7a1deb"

export default script